import rg4js from 'raygun4js';
import {
    useNavigate,
    useRouteError,
    isRouteErrorResponse,
    Link,
} from 'react-router';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { useEffect } from 'react';
import { Loader } from 'components/Loader/Loader';

const MODULE_ERROR = 'dynamically imported module';
const MODULE_ERROR_SAFARI = 'Importing a module script failed';

function getErrorOrMessageForRaygun(error: unknown): Error | string {
    if (error instanceof Error) {
        return error;
    } else if (isRouteErrorResponse(error)) {
        return `${error.status} ${error.statusText}`;
    } else if (typeof error === 'string') {
        return error;
    } else {
        return 'Unknown error';
    }
}

export const ErrorHandler = () => {
    const { t } = useTranslation('error');
    const navigate = useNavigate();
    const routeError = useRouteError();
    const errorOrMessage = getErrorOrMessageForRaygun(routeError);
    const message =
        errorOrMessage instanceof Error ? errorOrMessage.message : null;
    const isImportError =
        message?.includes(MODULE_ERROR) ||
        message?.includes(MODULE_ERROR_SAFARI);

    !isImportError &&
        rg4js('send', {
            ...(errorOrMessage instanceof Error && { error: errorOrMessage }),
            customData: [
                {
                    description: 'Error page displayed to user',
                    routeError,
                    ...(typeof errorOrMessage === 'string' && {
                        message: errorOrMessage,
                    }),
                },
            ],
        });

    useEffect(() => {
        if (isImportError) {
            navigate(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImportError]);

    if (isImportError) return <Loader />;

    return (
        <div className="bg-logo-img bg-center content-center bg-no-repeat h-screen flex items-center justify-center">
            <div className="grid grid-cols-2 gap-2">
                <h2 className="col-span-2 text-2xl">{t('subtitle')}</h2>
                <Button as={Link} className="justify-self-end" outline to="/">
                    {t('home')}
                </Button>
                <Button
                    className="justify-self-start"
                    onClick={() => navigate(0)}
                >
                    {t('reload')}
                </Button>
            </div>
        </div>
    );
};
